import { render, staticRenderFns } from "./EditDeviationCause.vue?vue&type=template&id=db56dd44&scoped=true&"
import script from "./EditDeviationCause.vue?vue&type=script&lang=js&"
export * from "./EditDeviationCause.vue?vue&type=script&lang=js&"
import style0 from "./EditDeviationCause.vue?vue&type=style&index=0&id=db56dd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db56dd44",
  null
  
)

/* custom blocks */
import block0 from "./EditDeviationCause.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports